const list = {
  path: 'list',
  component: resolve => require(['@/pages/admin/finance/list'], resolve),
  meta: {
    requireAuth: true
  }
}

export default list
